__turbopack_context__.v({
  "blog-module": "blog-module-module-scss-module__mxa7GW__blog-module",
  "blog-module-item": "blog-module-module-scss-module__mxa7GW__blog-module-item",
  "blog-title": "blog-module-module-scss-module__mxa7GW__blog-title",
});
